import React from 'react';
import { Description, SubTitle, Image } from '../../components/layouts';
import { buildImageURL, getTrack } from '../../helpers';
import './style.scss';

const IMAGE = buildImageURL('/desktop-b.png');

const track = getTrack({ block: 23 });

export function DesktopB() {
  return (
    <div className="page-section section-desktop-b inverted" data-track={track}>
      <div className="section-content center">
        <SubTitle>平行世界</SubTitle>
        <Description>OriginOS充满探索精神，我们在创新的同时保留了对传统的兼容。现在，你可以自由穿梭于探索与经典两个世界之间。</Description>
      </div>
      <Image src={IMAGE} className="pic" />
    </div>
  );
}
